import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';
import { cn } from '../../lib/cn';
import styles from './Button.module.css';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';
export type ButtonSize = 'sm' | 'md' | 'lg';

export type ButtonClassOptions = {
  variant?: ButtonVariant;
  size?: ButtonSize;
  className?: string;
};

export function getButtonClassNames({ variant = 'primary', size = 'md', className }: ButtonClassOptions = {}): string {
  return cn(
    styles.root,
    styles[`size_${size}`],
    styles[`variant_${variant}`],
    className
  );
}

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
  size?: ButtonSize;
  children?: ReactNode;
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'primary', size = 'md', className, type = 'button', children, ...rest },
  ref
) {
  return (
    <button ref={ref} type={type} className={getButtonClassNames({ variant, size, className })} {...rest}>
      {children}
    </button>
  );
});
